import debounce from 'lodash/debounce'
import store from '@state/store'
import formatDate from '@utils/format-date'

export function canAccess(role) {
  return store.getters['auth/userRole'] === role
}
export const tableAction = {
  watch: {
    innerCurrentPage: {
      handler: function (val) {
        this.$emit('page-changed', val)
      }
    },
    innerPerPage: {
      handler: function (val) {
        this.$emit('perpage-changed', val)
      }
    },
    currentPage: {
      handler: function(val) {
        this.$emit('page-changed', val)
      }
    },
    perPage: {
      handler: function(val) {
        this.$emit('perpage-changed', val)
      }
    },
    sortBy: {
      handler: function () {
        this.filterOn()
      }
    },
    sortDesc: {
      handler: function () {
        this.filterOn()
      }
    },
    filter: debounce(function(val) {
      this.filterOn(val)
    }, 500),
    filterCost: debounce(function(val) {
      this.reload()
    }, 500)
  },
  methods: {
    openModal(val) {
      if (val) {
        if (this.$data.inputs) {
          this.$data.inputs.forEach(element => {
            if (this.formConfig.formMode === 'Add') {
              Object.assign(this.$data.inputs, this.$options.data.apply(this).inputs)
            } else {
              if (element.name === 'isActive') {
                element.hidden = false
              } else if (element.name === 'password') {
                element.hidden = true
              }
            }
          })
        }
      }
    },
    closeModal(val) {
      if (val) {
        Object.assign(this.$data.inputs, this.$options.data.apply(this).inputs)
      }
    },
    formatTanggal(val, format) {
      return formatDate(val, format || 'MM/DD/YYYY')
    },
    sortOn(sort) {
      this.$emit('sorting', sort)
    },
    numberTable(index) {
      const start = (this.currentPage * this.perPage) - (this.perPage - 1);
      return start + index
    },
    makeToast(title, msg, toaster = 'b-toaster-top-right') {
      this.$bvToast.toast(`${msg}`, {
        title: title,
        toaster: toaster,
        autoHideDelay: 3000
      })
      this.isBusy = false
    },
    filterOn(val) {
      this.$emit('filter-changed', val)
    },
    editRow(item) {
      this.$emit('edit-row', item)
    },
    deleteRow(item) {
      this.$emit('delete-row', item)
    },
    getFieldName(fieldId) {
      const name = store.getters['field/fieldList'].find(item => {
        if (item.field_id === fieldId)
        return true
      })
      return name.field_name
    },
    splitForm(arr, key) {
      let count = 0
      const list = arr.reduce((result, item, index) => {
        result.push([])
        if (item.type === key) {
          count = count + 1
        } else {
          result[count].push(item)
        }
        return result
      }, [])
      return list.filter(function (el) {
        return el.length !== 0
      })
    },
    splitEvery(array) {
      let titles = []
      array.map(item => {
        if (item.type === 'section') {
          titles.push({label: item.label, options: item.options})
        }
      })
      const sections = this.splitForm(array, 'section')
      const res = sections.map((section, i) => {
        return { list: this.splitForm(section, 'column'), title: titles[i] }
      })
      return res
    }
  },
}
